<template>
    <el-container id="container">
        <common-header/>
        <el-main class="common_main">
            <router-view/>
        </el-main>
        <el-footer class="common_footer">
            <common-footer/>
        </el-footer>
    </el-container>
</template>

<script>
  import commonHeader from '@/components/Layout/commonHeader'
  import commonFooter from '@/components/Layout/commonFooter'


  export default {
    name: 'Wrapper',
    components: {
      commonHeader,
      commonFooter
    }
  }
</script>
